import React from "react";
import '../App.css';
import {useSpring, animated} from "react-spring";
import {easings} from "@react-spring/web";


function TutorialImage(props) {

    const style = useSpring({ to: { opacity: 1, marginTop: 0 }, from: { opacity: 0, marginTop: -100 }, config: {easing: easings.easeOutBack }})

    return(
        <>
            <animated.div style={style}>
                <img className={"infoIMG"} src={props.image.img}
                />
            </animated.div>
        </>
    );
}

export default TutorialImage